/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import React, { useState } from 'react';
import { fetchConToken } from 'helpers/fetch';
import Swal from 'sweetalert2';

const AsignarExistenciasArticulo = ({ id, GetSucursalId, articulo, setArticulo, almacenes, setReload, closeModal, setClavesArtVariant, getArticulo }) => {
    const isAddMode = !id;
    let [artVarianteId, setArtVarianteId] = useState(0);
    let [variantes, setVariantes] = useState([]);
    let [_almacenes, setAlmacenes] = useState(almacenes || []);
    let [existencia, setExistencia] = useState({
        id: 0,
        articulo_Id: parseInt(id ?? '0'),
        variante_Id: null,
        exis_Actual: 0,
        exis_Comprometida: 0,
        exis_Disponible: 0,
        almacen_Id: 0,
        sucursal_Id: GetSucursalId,
        movimiento: ''
    });

    async function getAlmacenes() {
        const almacenesAux = await fetchConToken(`Almacenes/GetList?paginas=0&totalXpagina=200&sucursal_Id=${GetSucursalId}`);
        setAlmacenes(almacenesAux.data);
        setExistencia({
            ...existencia,
            almacen_Id: almacenesAux.data[0]?.id
        });
    }

    function GetColumClassName() {
        if (variantes && variantes.length > 0) return !isAddMode ? 'col-md-3' : 'col-md-4';

        return !isAddMode ? 'col-md-5' : 'col-md-4';
    }

    const sincronizarExistencia = (articulo_id) => fetchConToken(`Articulos/SincronizarExistencia?articulo_id=${articulo_id}&sucursal_id=${GetSucursalId}`, null, 'PUT');

    const GuardarExistencia = () => {
        if (!(existencia.exis_Actual > 0)) {
            Swal.fire('Info', 'Seleccione un existencia valida', 'info');
            return;
        }

        if (variantes && variantes.length > 0) {
            if (!(artVarianteId > 0)) {
                Swal.fire('Info', 'Seleccione una variante', 'info');
                return;
            }

            existencia.variante_Id = artVarianteId;
        }
        else existencia.variante_Id = null;

        setExistencia(existencia);
        fetchConToken(`Existencias?actualizarEccomerce=true&sincronizarExistArt=false`, existencia, existencia.id > 0 ? 'PUT' : 'POST').then((response) => {
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }

            if (!(variantes && variantes.length > 0) && setArticulo) setArticulo({ ...articulo, existencias: existencia.exis_Actual });

            if (!isAddMode) {
                Swal.fire('Exito', 'Al Guardar la Existencia', 'success');
                sincronizarExistencia(id);
            }

            if (setClavesArtVariant) setClavesArtVariant([]);

            if (closeModal) closeModal();

            if (setReload) {
                setReload(true);
                setReload(false);
            }

            if (getArticulo) getArticulo();
            return true;
        }
        );
    };

    const handleInputChangeAlmacenMovimiento = ({ target }) => {
        setExistencia({
            ...existencia,
            [target.name]: target.value
        });
    };

    const handleInputChangeAlmacen = ({ target }) => {
        setExistencia({
            ...existencia,
            [target.name]: parseInt(target.value)
        });
    };

    function onChangeVarianteExistencia({ target }) {
        const { value } = target;
        setArtVarianteId(value);
    }

    React.useEffect(() => {
        if (articulo) setVariantes(articulo.articulo_Variantes || []);
        
        if (!(almacenes && almacenes.length > 0)) getAlmacenes();
    }, [articulo]);

    return (<div className='card text-left' style={{ padding: 10 }}>
        <div className='col-md-12 row'>
            {(variantes && variantes.length > 0) && (<div className='col-md-4'>
                <div className='card mb-2 '>
                    <div className='card-body text-start'>
                        <label htmlFor='calle'>Variante</label>
                        <select
                            className='form-select'
                            name='sinc_precio_empresa_id'
                            value={artVarianteId}
                            onChange={onChangeVarianteExistencia}
                        >
                            <option key={0} value={0} disabled>Seleccione la variante</option>
                            {variantes?.map((item) => (<option key={item.id} value={item.id}>{item.clave} - {item.nombre}</option>))}
                        </select>
                    </div>
                </div>
            </div>)}
            <div className={GetColumClassName()}>
                <div className='card-body text-start'>
                    <label htmlFor='calle'>Almacen</label>
                    <select
                        className='form-control'
                        name='almacen_Id'
                        value={existencia.almacen_Id}
                        onChange={handleInputChangeAlmacen}
                    >
                        {_almacenes.map((almacen) => (<option key={almacen.id} value={almacen.id}>{almacen.nombre}</option>))}
                    </select>
                </div>
            </div>
            <div className={GetColumClassName()}>
                <div className='card-body text-start'>
                    <label htmlFor='calle'>Existencia</label>
                    <input
                        type='number'
                        className='form-control'
                        name='exis_Actual'
                        value={existencia?.exis_Actual || ''}
                        onChange={handleInputChangeAlmacen}
                    />
                    <label htmlFor='calle'>Concepto</label>
                    <input
                        type='text'
                        className='form-control'
                        name='movimiento'
                        value={existencia?.movimiento || ''}
                        onChange={handleInputChangeAlmacenMovimiento}
                    />
                </div>
            </div>
            {!isAddMode && (<div className='col-md-2'>
                <button
                    className='btn btn-outline-success'
                    onClick={(e) => GuardarExistencia()}
                    type='button'
                >
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-check-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                    </svg>
                    &nbsp;Asignar
                </button>
            </div>)}
        </div>
    </div>);
}

export { AsignarExistenciasArticulo };